import { createSvgIcon } from "@mui/material";

export const Logo = createSvgIcon(
  <svg
    width="99"
    height="116"
    viewBox="0 0 99 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6610_15964)">
      <path
        d="M22.3618 26.3267C29.4832 26.3267 35.2563 20.4332 35.2563 13.1633C35.2563 5.89342 29.4832 0 22.3618 0C15.2404 0 9.46729 5.89342 9.46729 13.1633C9.46729 20.4332 15.2404 26.3267 22.3618 26.3267Z"
        fill="white"
      />
      <path
        d="M74.4199 47.0407C80.6523 47.0407 85.7046 41.883 85.7046 35.5208C85.7046 29.1585 80.6523 24.0009 74.4199 24.0009C68.1876 24.0009 63.1353 29.1585 63.1353 35.5208C63.1353 41.883 68.1876 47.0407 74.4199 47.0407Z"
        fill="white"
      />
      <path
        d="M9.18467 74.652C43.5188 116 47.0962 116 49.4624 116C53.3003 116 65.6362 109.189 86.1438 95.7505C86.2613 95.6734 86.3751 95.5911 86.485 95.5039C89.6236 93.5358 92.2755 90.8506 94.2298 87.6567C96.2912 84.2878 97.5138 80.4553 97.7911 76.4933C98.0683 72.5313 97.3918 68.5603 95.8206 64.9265C94.2493 61.2927 91.831 58.1065 88.7766 55.6458C85.7221 53.1852 82.1243 51.5248 78.297 50.8095C74.4696 50.0942 70.529 50.3457 66.8187 51.542C63.1084 52.7384 59.7412 54.8433 57.0108 57.6731C54.2803 60.503 52.2696 63.9718 51.1539 67.7771C50.8006 68.9819 50.9305 70.2806 51.5152 71.3875C52.0999 72.4944 53.0914 73.3189 54.2716 73.6796C55.4517 74.0403 56.7239 73.9076 57.8083 73.3107C58.8926 72.7138 59.7002 71.7017 60.0535 70.4969C60.7336 68.1721 61.9607 66.0525 63.6277 64.3231C65.2947 62.5937 67.351 61.3071 69.6171 60.5755C71.8832 59.8439 74.2903 59.6896 76.6282 60.126C78.9662 60.5624 81.164 61.5763 83.0298 63.0792C84.8957 64.5821 86.3729 66.5283 87.3326 68.748C88.2922 70.9677 88.7051 73.3934 88.5353 75.8135C88.3655 78.2335 87.6181 80.5744 86.3583 82.6318C85.0985 84.6892 83.3646 86.4005 81.308 87.6166C81.0889 87.746 80.8817 87.8928 80.688 88.055C68.8528 95.7914 54.7244 104.333 50.0743 106.21C45.2604 102.311 29.7299 84.7303 16.3584 68.6326L15.4735 67.4184L15.472 67.4165C12.0962 62.8077 9.86251 59.7581 9.86251 55.1457C9.85791 51.4122 11.2292 47.8134 13.7039 45.0645C16.1787 42.3155 19.5759 40.6174 23.2205 40.3075C26.8652 39.9976 30.4907 41.0986 33.3769 43.3918C36.263 45.685 38.1986 49.0025 38.799 52.6854C38.8861 53.3117 39.095 53.9139 39.4134 54.4566C39.7318 54.9993 40.1533 55.4715 40.6531 55.8454C41.1529 56.2194 41.7209 56.4875 42.3238 56.6341C42.9266 56.7806 43.552 56.8026 44.1633 56.6988C44.7745 56.595 45.3593 56.3674 45.8831 56.0295C46.407 55.6916 46.8593 55.2502 47.2136 54.7311C47.5679 54.2121 47.8169 53.626 47.946 53.0073C48.0751 52.3886 48.0817 51.7498 47.9655 51.1285C46.996 45.0865 43.8322 39.6393 39.1046 35.872C34.3769 32.1048 28.4325 30.2942 22.4557 30.8009C16.4788 31.3076 10.9084 34.0944 6.85425 38.6062C2.8001 43.1179 0.559893 49.0233 0.579968 55.1457C0.579968 62.9099 4.20045 67.855 8.03285 73.0895L8.03926 73.0983L8.99639 74.4086C9.05601 74.4918 9.11877 74.5719 9.18467 74.652Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6610_15964">
        <rect
          width="98"
          height="116"
          fill="white"
          transform="translate(0.580078)"
        />
      </clipPath>
    </defs>
  </svg>,
  "Logo"
);

export const KindergartenIconCircle = createSvgIcon(
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="38" height="38" rx="4" fill="#524086" />
    <circle cx="19.2988" cy="18.8999" r="10" fill="#A776E6" />
  </svg>,

  "KindergartenIconCircle"
);

export const HomeIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.1111 6.81339L11.7778 2.61042C11.2889 2.21732 10.656 2 10 2C9.34409 2 8.71117 2.21732 8.22226 2.61042L2.88897 6.81339C2.60663 7.04037 2.38133 7.31883 2.22806 7.6302C2.07479 7.94158 1.99707 8.27874 2.00008 8.61923V15.6029C2.00008 16.2386 2.28103 16.8483 2.78113 17.2979C3.28122 17.7474 3.95949 18 4.66673 18H15.3333C16.0406 18 16.7188 17.7474 17.2189 17.2979C17.719 16.8483 18 16.2386 18 15.6029V8.61123C18.0017 8.27209 17.9234 7.93647 17.7702 7.62656C17.6169 7.31664 17.3923 7.03948 17.1111 6.81339ZM11.7778 16.4019H8.22226V12.4067C8.22226 12.1948 8.31591 11.9915 8.48261 11.8417C8.64931 11.6918 8.8754 11.6076 9.11114 11.6076H10.8889C11.1247 11.6076 11.3507 11.6918 11.5174 11.8417C11.6841 11.9915 11.7778 12.1948 11.7778 12.4067V16.4019ZM16.2222 15.6029C16.2222 15.8148 16.1286 16.018 15.9619 16.1679C15.7952 16.3177 15.5691 16.4019 15.3333 16.4019H13.5556V12.4067C13.5556 11.7709 13.2746 11.1612 12.7745 10.7117C12.2744 10.2621 11.5961 10.0096 10.8889 10.0096H9.11114C8.40391 10.0096 7.72563 10.2621 7.22554 10.7117C6.72545 11.1612 6.4445 11.7709 6.4445 12.4067V16.4019H4.66673C4.43099 16.4019 4.2049 16.3177 4.0382 16.1679C3.8715 16.018 3.77785 15.8148 3.77785 15.6029V8.61123C3.77801 8.49778 3.80504 8.38566 3.85715 8.28233C3.90926 8.179 3.98525 8.08683 4.08007 8.01195L9.41336 3.81697C9.57558 3.68887 9.78411 3.61822 10 3.61822C10.2159 3.61822 10.4245 3.68887 10.5867 3.81697L15.92 8.01195C16.0148 8.08683 16.0908 8.179 16.1429 8.28233C16.195 8.38566 16.222 8.49778 16.2222 8.61123V15.6029Z" />
  </svg>,
  "HomeIcon"
);

export const SettingsIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_6782_10039"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" />
    </mask>
    <g mask="url(#mask0_6782_10039)">
      <path d="M14.0519 16.5312C13.2207 16.5312 12.5181 16.2443 11.9441 15.6703C11.3702 15.0964 11.0832 14.3938 11.0832 13.5625C11.0832 12.7312 11.3702 12.0286 11.9441 11.4547C12.5181 10.8807 13.2207 10.5938 14.0519 10.5938C14.8832 10.5938 15.5858 10.8807 16.1597 11.4547C16.7337 12.0286 17.0207 12.7312 17.0207 13.5625C17.0207 14.3938 16.7337 15.0964 16.1597 15.6703C15.5858 16.2443 14.8832 16.5312 14.0519 16.5312ZM14.0519 14.9479C14.4346 14.9479 14.7611 14.8127 15.0316 14.5422C15.3021 14.2717 15.4373 13.9451 15.4373 13.5625C15.4373 13.1799 15.3021 12.8533 15.0316 12.5828C14.7611 12.3123 14.4346 12.1771 14.0519 12.1771C13.6693 12.1771 13.3427 12.3123 13.0722 12.5828C12.8017 12.8533 12.6665 13.1799 12.6665 13.5625C12.6665 13.9451 12.8017 14.2717 13.0722 14.5422C13.3427 14.8127 13.6693 14.9479 14.0519 14.9479ZM3.1665 14.3542V12.7708H9.49984V14.3542H3.1665ZM4.94775 9.40625C4.1165 9.40625 3.4139 9.11927 2.83994 8.54531C2.26598 7.97135 1.979 7.26875 1.979 6.4375C1.979 5.60625 2.26598 4.90365 2.83994 4.32969C3.4139 3.75573 4.1165 3.46875 4.94775 3.46875C5.779 3.46875 6.48161 3.75573 7.05557 4.32969C7.62952 4.90365 7.9165 5.60625 7.9165 6.4375C7.9165 7.26875 7.62952 7.97135 7.05557 8.54531C6.48161 9.11927 5.779 9.40625 4.94775 9.40625ZM4.94775 7.82292C5.33039 7.82292 5.65696 7.68767 5.92744 7.41719C6.19793 7.1467 6.33317 6.82014 6.33317 6.4375C6.33317 6.05486 6.19793 5.7283 5.92744 5.45781C5.65696 5.18733 5.33039 5.05208 4.94775 5.05208C4.56511 5.05208 4.23855 5.18733 3.96807 5.45781C3.69758 5.7283 3.56234 6.05486 3.56234 6.4375C3.56234 6.82014 3.69758 7.1467 3.96807 7.41719C4.23855 7.68767 4.56511 7.82292 4.94775 7.82292ZM9.49984 7.22917V5.64583H15.8332V7.22917H9.49984Z" />
    </g>
  </svg>,
  "GroupsIcon"
);

export const GroupsIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_6782_10029"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" />
    </mask>
    <g>
      <path d="M15.1125 7.77778C14.4202 7.77778 13.8148 7.5679 13.2963 7.14815C12.7778 6.7284 12.4444 6.19753 12.2963 5.55556H7.68363C7.54886 6.08642 7.29321 6.54012 6.91667 6.91667C6.54012 7.29321 6.08642 7.54886 5.55556 7.68363V12.2963C6.19753 12.4444 6.7284 12.7778 7.14815 13.2963C7.5679 13.8148 7.77778 14.4202 7.77778 15.1125C7.77778 15.914 7.49691 16.5957 6.93519 17.1574C6.37346 17.7191 5.69136 18 4.88889 18C4.08642 18 3.40432 17.7191 2.84259 17.1574C2.28086 16.5957 2 15.914 2 15.1125C2 14.4202 2.20988 13.8148 2.62963 13.2963C3.04938 12.7778 3.58025 12.4444 4.22222 12.2963V7.68519C3.58025 7.53704 3.04938 7.20622 2.62963 6.69274C2.20988 6.17926 2 5.58019 2 4.89554C2 4.08864 2.28086 3.40432 2.84259 2.84259C3.40432 2.28086 4.08864 2 4.89554 2C5.58019 2 6.17926 2.20988 6.69274 2.62963C7.20622 3.04938 7.53704 3.58025 7.68519 4.22222H12.2963C12.4444 3.58025 12.7778 3.04938 13.2963 2.62963C13.8148 2.20988 14.4202 2 15.1125 2C15.914 2 16.5957 2.28086 17.1574 2.84259C17.7191 3.40432 18 4.08642 18 4.88889C18 5.69136 17.7191 6.37346 17.1574 6.93519C16.5957 7.49691 15.914 7.77778 15.1125 7.77778ZM4.88889 16.6667C5.31667 16.6667 5.68287 16.5154 5.9875 16.213C6.29213 15.9105 6.44444 15.5432 6.44444 15.1111C6.44444 14.6833 6.29213 14.3171 5.9875 14.0125C5.68287 13.7079 5.31667 13.5556 4.88889 13.5556C4.45679 13.5556 4.08951 13.7079 3.78704 14.0125C3.48457 14.3171 3.33333 14.6833 3.33333 15.1111C3.33333 15.5432 3.48457 15.9105 3.78704 16.213C4.08951 16.5154 4.45679 16.6667 4.88889 16.6667ZM4.88889 6.44444C5.31667 6.44444 5.68287 6.29168 5.9875 5.98615C6.29213 5.68062 6.44444 5.31333 6.44444 4.8843C6.44444 4.45526 6.29213 4.08951 5.9875 3.78704C5.68287 3.48457 5.31667 3.33333 4.88889 3.33333C4.45679 3.33333 4.08951 3.4861 3.78704 3.79163C3.48457 4.09716 3.33333 4.46444 3.33333 4.89348C3.33333 5.32252 3.48457 5.68827 3.78704 5.99074C4.08951 6.29321 4.45679 6.44444 4.88889 6.44444ZM15.1026 18C14.3058 18 13.6265 17.7191 13.0648 17.1574C12.5031 16.5957 12.2222 15.9164 12.2222 15.1196C12.2222 14.3228 12.5031 13.6407 13.0648 13.0733C13.6265 12.5059 14.3058 12.2222 15.1026 12.2222C15.8994 12.2222 16.5815 12.5059 17.1489 13.0733C17.7163 13.6407 18 14.3228 18 15.1196C18 15.9164 17.7163 16.5957 17.1489 17.1574C16.5815 17.7191 15.8994 18 15.1026 18ZM15.1157 16.6667C15.5447 16.6667 15.9105 16.5154 16.213 16.213C16.5154 15.9105 16.6667 15.5432 16.6667 15.1111C16.6667 14.6833 16.5139 14.3171 16.2084 14.0125C15.9028 13.7079 15.5356 13.5556 15.1065 13.5556C14.6775 13.5556 14.3117 13.7079 14.0093 14.0125C13.7068 14.3171 13.5556 14.6833 13.5556 15.1111C13.5556 15.5432 13.7083 15.9105 14.0139 16.213C14.3194 16.5154 14.6867 16.6667 15.1157 16.6667ZM15.1157 6.44444C15.5447 6.44444 15.9105 6.29168 16.213 5.98615C16.5154 5.68062 16.6667 5.31333 16.6667 4.8843C16.6667 4.45526 16.5139 4.08951 16.2084 3.78704C15.9028 3.48457 15.5356 3.33333 15.1065 3.33333C14.6775 3.33333 14.3117 3.4861 14.0093 3.79163C13.7068 4.09716 13.5556 4.46444 13.5556 4.89348C13.5556 5.32252 13.7083 5.68827 14.0139 5.99074C14.3194 6.29321 14.6867 6.44444 15.1157 6.44444Z" />
    </g>
  </svg>,
  "GroupsIcon"
);

export const TeachersIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.8 11.5C11.9031 11.5 11.4719 12 10 12C8.52812 12 8.1 11.5 7.2 11.5C4.88125 11.5 3 13.3813 3 15.7V16.5C3 17.3281 3.67188 18 4.5 18H15.5C16.3281 18 17 17.3281 17 16.5V15.7C17 13.3813 15.1187 11.5 12.8 11.5ZM15.5 16.5H4.5V15.7C4.5 14.2125 5.7125 13 7.2 13C7.65625 13 8.39687 13.5 10 13.5C11.6156 13.5 12.3406 13 12.8 13C14.2875 13 15.5 14.2125 15.5 15.7V16.5ZM10 11C12.4844 11 14.5 8.98438 14.5 6.5C14.5 4.01562 12.4844 2 10 2C7.51562 2 5.5 4.01562 5.5 6.5C5.5 8.98438 7.51562 11 10 11ZM10 3.5C11.6531 3.5 13 4.84687 13 6.5C13 8.15312 11.6531 9.5 10 9.5C8.34688 9.5 7 8.15312 7 6.5C7 4.84687 8.34688 3.5 10 3.5Z" />
  </svg>,
  "TeachersIcon"
);

export const ChildrenIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_6813_7388"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" />
    </mask>
    <g mask="url(#mask0_6813_7388)">
      <path d="M9.51165 13.7895C10.1752 13.7895 10.7655 13.59 11.2825 13.1911C11.7996 12.7922 12.1837 12.2825 12.4349 11.6621H6.58449C6.83564 12.2825 7.22041 12.7922 7.73879 13.1911C8.25716 13.59 8.84811 13.7895 9.51165 13.7895ZM7.38227 10.5983C7.67775 10.5983 7.9289 10.4949 8.13573 10.2881C8.34257 10.0813 8.44598 9.8301 8.44598 9.53463C8.44598 9.23915 8.34257 8.988 8.13573 8.78116C7.9289 8.57433 7.67775 8.47091 7.38227 8.47091C7.0868 8.47091 6.83564 8.57433 6.62881 8.78116C6.42198 8.988 6.31856 9.23915 6.31856 9.53463C6.31856 9.8301 6.42198 10.0813 6.62881 10.2881C6.83564 10.4949 7.0868 10.5983 7.38227 10.5983ZM11.6371 10.5983C11.9326 10.5983 12.1837 10.4949 12.3906 10.2881C12.5974 10.0813 12.7008 9.8301 12.7008 9.53463C12.7008 9.23915 12.5974 8.988 12.3906 8.78116C12.1837 8.57433 11.9326 8.47091 11.6371 8.47091C11.3416 8.47091 11.0905 8.57433 10.8837 8.78116C10.6768 8.988 10.5734 9.23915 10.5734 9.53463C10.5734 9.8301 10.6768 10.0813 10.8837 10.2881C11.0905 10.4949 11.3416 10.5983 11.6371 10.5983ZM5.83103 5.76731L8.2687 2.6205C8.42848 2.40699 8.61821 2.25019 8.83789 2.15012C9.0576 2.05004 9.28728 2 9.52694 2C9.7666 2 9.99354 2.05171 10.2078 2.15512C10.422 2.25854 10.6103 2.41367 10.7729 2.6205L13.2105 5.76731L16.9335 6.98615C17.2733 7.10434 17.5392 7.30154 17.7313 7.57775C17.9234 7.85395 18.0194 8.15905 18.0194 8.49307C18.0194 8.65149 17.997 8.80992 17.9522 8.96835C17.9074 9.12677 17.8337 9.2786 17.7313 9.42382L15.3379 12.7701L15.4266 16.3601C15.4266 16.8181 15.2715 17.2059 14.9612 17.5235C14.651 17.8412 14.2803 18 13.8493 18C13.8223 18 13.6833 17.9778 13.4321 17.9335L9.5097 16.8476L5.58606 17.9344C5.51299 17.9633 5.44321 17.9815 5.37673 17.9889C5.31025 17.9963 5.24355 18 5.17664 18C4.74837 18 4.37363 17.8412 4.05243 17.5235C3.73124 17.2059 3.57802 16.8181 3.5928 16.3601L3.68144 12.7701L1.28809 9.42382C1.18467 9.27608 1.1108 9.12835 1.06648 8.98061C1.02216 8.83287 1 8.67755 1 8.51464C1 8.17524 1.09737 7.86505 1.29212 7.58407C1.48687 7.30308 1.75884 7.10378 2.10803 6.98615L5.83103 5.76731ZM6.76177 7.14127L2.59557 8.51524L5.27479 12.3057L5.18837 16.4044L9.5097 15.1856L13.8532 16.3823L13.7424 12.2825L16.4238 8.49307L12.2355 7.14127L9.5097 3.63989L6.76177 7.14127Z" />
    </g>
  </svg>,
  "ChildrenIcon"
);

export const ParentsIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_6813_12386"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" />
    </mask>
    <g mask="url(#mask0_6813_12386)">
      <path d="M15.5 7.5C15.7833 7.5 16.0208 7.40417 16.2125 7.2125C16.4042 7.02083 16.5 6.78333 16.5 6.5C16.5 6.21667 16.4042 5.97917 16.2125 5.7875C16.0208 5.59583 15.7833 5.5 15.5 5.5C15.2167 5.5 14.9792 5.59583 14.7875 5.7875C14.5958 5.97917 14.5 6.21667 14.5 6.5C14.5 6.78333 14.5958 7.02083 14.7875 7.2125C14.9792 7.40417 15.2167 7.5 15.5 7.5ZM15.5 9C14.7917 9 14.1979 8.76042 13.7188 8.28125C13.2396 7.80208 13 7.20833 13 6.5C13 5.80556 13.2396 5.21528 13.7188 4.72917C14.1979 4.24306 14.7917 4 15.5 4C16.1944 4 16.7847 4.24306 17.2708 4.72917C17.7569 5.21528 18 5.80556 18 6.5C18 7.20833 17.7569 7.80208 17.2708 8.28125C16.7847 8.76042 16.1944 9 15.5 9ZM10 6C10.3472 6 10.6424 5.88194 10.8854 5.64583C11.1285 5.40972 11.25 5.11111 11.25 4.75C11.25 4.40278 11.1285 4.10764 10.8854 3.86458C10.6424 3.62153 10.3472 3.5 10 3.5C9.63889 3.5 9.34028 3.62153 9.10417 3.86458C8.86806 4.10764 8.75 4.40278 8.75 4.75C8.75 5.11111 8.86806 5.40972 9.10417 5.64583C9.34028 5.88194 9.63889 6 10 6ZM9.99929 7.5C9.23588 7.5 8.58681 7.23264 8.05208 6.69792C7.51736 6.16319 7.25 5.51413 7.25 4.75071C7.25 4.00024 7.51736 3.35417 8.05208 2.8125C8.58681 2.27083 9.23588 2 9.99929 2C10.7498 2 11.3958 2.27083 11.9375 2.8125C12.4792 3.35417 12.75 4.00024 12.75 4.75071C12.75 5.51413 12.4792 6.16319 11.9375 6.69792C11.3958 7.23264 10.7498 7.5 9.99929 7.5ZM6.5 11.75C6.5 12.1667 6.77431 12.7083 7.32292 13.375C7.87153 14.0417 8.76389 14.9167 10 16C11.3889 14.7361 12.3194 13.8194 12.7917 13.25C13.2639 12.6806 13.5 12.1806 13.5 11.75C13.5 11.3889 13.3819 11.0903 13.1458 10.8542C12.9097 10.6181 12.6111 10.5 12.25 10.5C12.0417 10.5 11.8368 10.5486 11.6354 10.6458C11.434 10.7431 11.2639 10.8681 11.125 11.0208L10.2917 12H9.6875L8.85417 11.0208C8.71528 10.8681 8.54514 10.7431 8.34375 10.6458C8.14236 10.5486 7.94136 10.5 7.74075 10.5C7.38581 10.5 7.09028 10.6181 6.85417 10.8542C6.61806 11.0903 6.5 11.3889 6.5 11.75ZM5 11.75C5 11 5.26736 10.3542 5.80208 9.8125C6.33681 9.27083 6.98611 9 7.75 9C8.17567 9 8.58417 9.09375 8.9755 9.28125C9.36683 9.46875 9.70833 9.72222 10 10.0417C10.2814 9.72115 10.6192 9.46742 11.0132 9.28046C11.4072 9.09349 11.8194 9 12.25 9C13 9 13.6458 9.27083 14.1875 9.8125C14.7292 10.3542 15 11 15 11.75C15 12.4583 14.7535 13.1632 14.2604 13.8646C13.7674 14.566 12.9097 15.4444 11.6875 16.5L10 17.9583L8.3125 16.5C7.07639 15.4306 6.21528 14.5451 5.72917 13.8438C5.24306 13.1424 5 12.4444 5 11.75ZM4.5 7.5C4.78333 7.5 5.02083 7.40417 5.2125 7.2125C5.40417 7.02083 5.5 6.78333 5.5 6.5C5.5 6.21667 5.40417 5.97917 5.2125 5.7875C5.02083 5.59583 4.78333 5.5 4.5 5.5C4.21667 5.5 3.97917 5.59583 3.7875 5.7875C3.59583 5.97917 3.5 6.21667 3.5 6.5C3.5 6.78333 3.59583 7.02083 3.7875 7.2125C3.97917 7.40417 4.21667 7.5 4.5 7.5ZM10.0625 18V16.5H16.5V11.5H14.3333V10H16.4986C16.9023 10 17.2535 10.1493 17.5521 10.4479C17.8507 10.7465 18 11.0947 18 11.4924V18H10.0625ZM3.5 16.5H10.0625V18H2V11.4924C2 11.0947 2.14583 10.7465 2.4375 10.4479C2.72917 10.1493 3.0816 10 3.49479 10H5.64583V11.5H3.5V16.5ZM4.5 9C3.79167 9 3.19792 8.76042 2.71875 8.28125C2.23958 7.80208 2 7.20833 2 6.5C2 5.80556 2.23958 5.21528 2.71875 4.72917C3.19792 4.24306 3.79167 4 4.5 4C5.19444 4 5.78472 4.24306 6.27083 4.72917C6.75694 5.21528 7 5.80556 7 6.5C7 7.20833 6.75694 7.80208 6.27083 8.28125C5.78472 8.76042 5.19444 9 4.5 9Z" />
    </g>
  </svg>,
  "ParentsIcon"
);

export const FileIcon = createSvgIcon(
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2.5H6C4.9 2.5 4.01 3.4 4.01 4.5L4 20.5C4 21.6 4.89 22.5 5.99 22.5H18C19.1 22.5 20 21.6 20 20.5V8.5L14 2.5ZM18 20.5H6V4.5H13V9.5H18V20.5ZM8 15.51L9.41 16.92L11 15.34V19.5H13V15.34L14.59 16.93L16 15.51L12.01 11.5L8 15.51Z"
      fill="#3F3273"
    />
  </svg>,
  "FileIcon"
);

export const WhiteCross = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_6942_15324"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6942_15324)">
      <path
        d="M7.3 19L6 17.7L11.2 12.5L6 7.3L7.3 6L12.5 11.2L17.7 6L19 7.3L13.8 12.5L19 17.7L17.7 19L12.5 13.8L7.3 19Z"
        fill="white"
      />
    </g>
  </svg>,
  "WhiteCross"
);

export const TrashCan = createSvgIcon(
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00002 16.3333C5.00002 17.25 5.75002 18 6.66669 18H13.3334C14.25 18 15 17.25 15 16.3333V6.33333H5.00002V16.3333ZM15.8334 3.83333H12.9167L12.0834 3H7.91669L7.08335 3.83333H4.16669V5.5H15.8334V3.83333Z"
      fill="#483359"
    />
  </svg>,
  "TrashCan"
);

export const PencilIcon = createSvgIcon(
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_7002_25378"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect y="0.5" width="21" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7002_25378)">
      <path
        d="M4.375 16.3333H5.62188L14.175 8.1875L12.9281 7L4.375 15.1458V16.3333ZM2.625 18V14.4583L14.175 3.47917C14.35 3.32639 14.5432 3.20833 14.7547 3.125C14.9661 3.04167 15.1885 3 15.4219 3C15.6552 3 15.8813 3.04167 16.1 3.125C16.3188 3.20833 16.5083 3.33333 16.6688 3.5L17.8719 4.66667C18.0469 4.81944 18.1745 5 18.2547 5.20833C18.3349 5.41667 18.375 5.625 18.375 5.83333C18.375 6.05556 18.3349 6.26736 18.2547 6.46875C18.1745 6.67014 18.0469 6.85417 17.8719 7.02083L6.34375 18H2.625ZM13.5406 7.60417L12.9281 7L14.175 8.1875L13.5406 7.60417Z"
        fill="#483359"
      />
    </g>
  </svg>,
  "PencilIcon"
);

export const PlusCircle = createSvgIcon(
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_7002_25136"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="29"
      height="28"
    >
      <rect x="0.5" width="28" height="28" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7002_25136)">
      <path
        d="M13.625 19.5429H15.375V14.8762H20.0416V13.1263H15.375V8.45964H13.625V13.1263H8.95835V14.8762H13.625V19.5429ZM14.5019 25.0846C12.969 25.0846 11.5282 24.7937 10.1793 24.2119C8.83049 23.6301 7.65719 22.8406 6.65944 21.8433C5.66166 20.846 4.87176 19.6732 4.28973 18.3249C3.7077 16.9767 3.41669 15.5361 3.41669 14.0032C3.41669 12.4703 3.70758 11.0294 4.28935 9.68061C4.87113 8.33177 5.66067 7.15847 6.65798 6.16072C7.6553 5.16295 8.82809 4.37305 10.1763 3.79102C11.5245 3.20899 12.9651 2.91797 14.498 2.91797C16.031 2.91797 17.4718 3.20886 18.8207 3.79064C20.1695 4.37241 21.3428 5.16196 22.3405 6.15926C23.3383 7.15659 24.1282 8.32937 24.7103 9.67761C25.2923 11.0258 25.5833 12.4664 25.5833 13.9993C25.5833 15.5322 25.2924 16.9731 24.7106 18.3219C24.1289 19.6708 23.3393 20.8441 22.342 21.8418C21.3447 22.8396 20.1719 23.6295 18.8237 24.2115C17.4754 24.7936 16.0349 25.0846 14.5019 25.0846ZM14.5 23.3346C17.1055 23.3346 19.3125 22.4304 21.1208 20.6221C22.9292 18.8138 23.8333 16.6068 23.8333 14.0013C23.8333 11.3957 22.9292 9.18877 21.1208 7.38044C19.3125 5.57211 17.1055 4.66794 14.5 4.66794C11.8944 4.66794 9.68749 5.57211 7.87916 7.38044C6.07082 9.18877 5.16666 11.3957 5.16666 14.0013C5.16666 16.6068 6.07082 18.8138 7.87916 20.6221C9.68749 22.4304 11.8944 23.3346 14.5 23.3346Z"
        fill="#B5BCC4"
      />
    </g>
  </svg>,
  "PlusCircle"
);
